module.exports = __webpack_public_path__ + "img/dodDownloadIcon.a7ba47b2.svg";